import { BannerApiResponse } from '../types';
import { ENDPOINTS } from '../consts/endpoints';
import { AbstractApi } from '../../abstract-api';

export class BannerApi extends AbstractApi {
  async getBanner(): Promise<BannerApiResponse> {
    const axios = await this.axios();
    const { data } = await axios.get<BannerApiResponse>(ENDPOINTS.CONTENT.BANNER);
    return data;
  }
}
